import Api from 'components/Api';
import React, { useEffect, useRef } from 'react';
import Dialog from 'components/ui/Dialog';
import Button from 'components/ui/Button';
import { MODALS } from 'components/ui/redux/Actions';
import UiMsg from 'components/ui/UiMsg';
import ObjectRightMenu from 'components/ui/right-menu/ObjectRightMenu';
import useBimContext from 'components/hooks/useBimContext';
import useReduxDispatch from 'components/hooks/useReduxDispatch';

export function FixedMembersConfirmDialog({ mdxHTML = '', closeModal = _.noop, handleConfirmSave = _.noop }) {
  const context = useBimContext();

  const confirmAndClose = () => {
    handleConfirmSave();
    closeModal();
  };

  return (
    <Dialog onClose={closeModal} title={context.msg.t('attention')}>
      <div className="row-fluid">
        <div className="span12">
          <p className="dialog-text">{context.msg.t('fixed.members.alert.message')}</p>
        </div>
      </div>
      <div className="row-fluid">
        <div className="span12">
          <fieldset>
            <legend>{context.msg.t('occurrences.found')}</legend>
          </fieldset>
          <pre className="fixed-members-mdx" dangerouslySetInnerHTML={{ __html: mdxHTML }} />
        </div>
      </div>
      <div className="row-fluid">
        <div className="span12 text-right btn-fix">
          <Button onClick={closeModal} className={`bng-button cancel`}>
            {context.msg.t('cancel')}
          </Button>{' '}
          <Button className={`bng-button save`} type="button" onClick={confirmAndClose} style={{ width: 'auto' }}>
            {context.msg.t('save.anyway')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default function AnalysisRightMenu(props) {
  const context = useBimContext();
  const dispatch = useReduxDispatch();

  const $formik = useRef();

  useEffect(() => {
    $formik.current.setFieldValue('objectConfig.description', props.description);
  }, [props.description]);

  return (
    <ObjectRightMenu
      context={context}
      {...props}
      saveAs={Api.Analysis.saveAs}
      onFormikRef={$formik}
      toggleAnalystMenu={(clearAccordion = _.noop) => {
        clearAccordion();
        Api.executeExp(`#{analysisBean.toggleAnalystMenu()}`);
      }}
      closeAnalystMenu={() => {
        Api.executeExp(`#{analysisBean.setCloseAnalystMenu(true)}`);
      }}
      save={async ({ submitForm, values }) => {
        const saveAnalysis = async () => {
          const description = values?.objectConfig?.description;
          if (!_.isNil(description)) {
            await Api.Analysis.updateDescription(description);
          }
          await Api.executeExp(`#{analysisBean.confirmedSaveAnalysis()}`);
          await submitForm();
        };

        try {
          const data = await Api.Analysis.hasFixedMembers();
          if (data.containFixedMembers) {
            dispatch(
              MODALS.open(FixedMembersConfirmDialog, {
                mdxHTML: data.mdx,
                handleConfirmSave: () => saveAnalysis(),
              })
            );
          } else {
            await saveAnalysis();
          }
        } catch (e) {
          console.error(e);
          UiMsg.error('Error', e);
        }
      }}
      remove={async () => {
        await Api.executeExp(`#{analysisBean.removeCurrentAnalysis()}`);
      }}
    />
  );
}
